// @flow

import { gql } from '@apollo/client';

export const GET_AUTH = gql`
  query GetAuth {
    auth @client {
      token
      expireAt
      email
      isConnected
      partnerHeaderCode
    }
  }
`;
